import React, { useEffect } from 'react';
import animateScrollTo from 'animated-scroll-to';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import ProgramsItem from './programsItemComponent';
import Spinner from '../../../common/Spinner/Spinner';

const Programs = ({ fetchProgramsDataIfNeeded, programsData }) => {
    useEffect(() => {
        animateScrollTo(0, { speed: 700 });

        fetchProgramsDataIfNeeded();
    // Disabled the following rule because I want to use this only on initial render (like didMount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function _mapPrograms() {
        return programsData.map((item) => (
            <ProgramsItem
                key={item.programTitle}
                title={item.programTitle}
                image={item.programImage}
                resume={item.programDescription}
                days={item.programDays}
                time={item.programTime}
            />
        ));
    }

    return (
        <section className="SectionPrograms">
            <header>
                <h1>Programação</h1>
                <p className="tw-text-black tw-text-center">
                    Clássicos, Montagens e o melhor da Música Internacional
                </p>
            </header>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
                {programsData.length > 0 ? _mapPrograms() : <Spinner />}
            </div>
        </section>
    );
};

Programs.propTypes = exact({
    fetchProgramsDataIfNeeded: PropTypes.func.isRequired,
    programsData: PropTypes.arrayOf(
        PropTypes.shape({
            programTitle: PropTypes.string.isRequired,
            programImage: PropTypes.string.isRequired,
            programDescription: PropTypes.string.isRequired,
            programDays: PropTypes.string.isRequired,
            programTime: PropTypes.string.isRequired,
        }),
    ).isRequired,
});

export default Programs;
